"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
/****************************************************
 * Audit Big Data System Query Engine
 * 模型旋转-交叉字段设置
 * 2020-09
 * Sunny <tufpsj@yonyou.com>
 ****************************************************/
var React = require("react");
var react_1 = require("react");
var tinper_bee_1 = require("tinper-bee");
var Message_1 = require("./Message");
var utils_1 = require("../utils");
require("../style/CrossRotate.css");
var CheckboxGroup = tinper_bee_1.Checkbox.CheckboxGroup;
/**
 * 模型旋转-交叉字段每组对象(如：待选字段、已选字段、值字段等)
 */
var FieldsContainer = /** @class */ (function (_super) {
    __extends(FieldsContainer, _super);
    function FieldsContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            values: [],
            _options: [],
            checkValues: [],
        };
        _this.fieldItems2TinperListItems = function (fieldItems) {
            return fieldItems.map(function (item) {
                return {
                    label: item.title,
                    value: item.key,
                };
            });
        };
        _this.tinperListItems2FieldItems = function (tinperListItems) {
            return tinperListItems.map(function (item) {
                // fixed 由于tinper-bee升级，导致原有传递的对象转为传递string，这里进行特殊处理 2022-9-28 --by 若雨成霜
                return {
                    key: item,
                    title: item,
                };
            });
        };
        _this.onChange = function (checkedValues) {
            var _values = _this.tinperListItems2FieldItems(checkedValues);
            _this.setState({
                values: _values,
                checkValues: checkedValues,
            });
        };
        _this.getValue = function () {
            return _this.tinperListItems2FieldItems(_this.state.checkValues);
        };
        _this.getOptions = function () {
            var _fields = (_this.props.fields || []).filter(function (item) {
                return item || item != null;
            });
            return _fields.map(function (item) {
                return {
                    value: item.key,
                    label: item.title,
                };
            });
        };
        _this.props.cRef && _this.props.cRef(_this);
        return _this;
    }
    FieldsContainer.prototype.componentDidMount = function () {
        this.setState({
            _options: this.fieldItems2TinperListItems(this.props.fields),
            values: this.props.fields || [],
            checkValues: [],
        });
    };
    FieldsContainer.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "CrossRotateTitle" }, this.props.title),
            React.createElement("div", { className: "CrossRotate" },
                React.createElement(CheckboxGroup, { options: this.state._options, onChange: this.onChange }))));
    };
    return FieldsContainer;
}(react_1.PureComponent));
/**
 * 字段集合行列互换设置对话框
 *
 * 弹出行列互换设置对话框，组件组织方式是 CrossRotate(ReactNode) 1..n FieldsContainer(ReactNode) 1..n CrossRotateFieldItem(PlainObject)
 *
 */
var CrossRotate = /** @class */ (function (_super) {
    __extends(CrossRotate, _super);
    function CrossRotate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            fields: utils_1.Utils.cloneObject(_this.props.fields) || [],
            rowFields: _this.props.rowFields || [],
            colFields: _this.props.colFields || [],
            valueFields: _this.props.valueFields || [],
            body: "body",
            valueContainerKey: "valueContainerKey",
            colContainerKey: "colContainerKey",
            show: _this.props.show,
        };
        _this.fieldsRef = null;
        _this.rowFieldsRef = null;
        _this.colFieldsRef = null;
        _this.valueFieldsRef = null;
        _this.containerKey = 'primary';
        _this.fields = [];
        /**
         * 增加行字段
         */
        _this._rightRow = function () {
            var selectFields = _this.fieldsRef.getValue() || [];
            if (selectFields.length === 0) {
                Message_1.default.showMessage((0, utils_1.getTranslate)(null, "至少选择一项"));
                return;
            }
            var rowFields = _this.state.rowFields || [];
            selectFields.forEach(function (item) {
                rowFields.push(item);
            });
            var newFields = _this.state.fields.filter(function (itm) {
                var found = false;
                for (var i = 0; i < selectFields.length; i++) {
                    try {
                        if (itm.title === selectFields[i].title ||
                            itm.key === selectFields[i].title) {
                            found = true;
                            break;
                        }
                    }
                    catch (e) {
                        console.error(e.message);
                    }
                }
                return !found;
            });
            _this.setState({
                fields: newFields,
                rowFields: rowFields,
                body: "body" + Math.random(),
            }, function () {
            });
        };
        /**
         * 移除行字段
         */
        _this._leftRow = function () {
            var selectFields = _this.rowFieldsRef.getValue() || [];
            var fields = _this.state.fields || [];
            selectFields.forEach(function (item) {
                fields.push(item);
            });
            var newFields = _this.state.rowFields.filter(function (itm) {
                var found = false;
                for (var i = 0; i < selectFields.length; i++) {
                    try {
                        if (itm.title === selectFields[i].title) {
                            found = true;
                            break;
                        }
                    }
                    catch (e) {
                    }
                }
                return !found;
            });
            _this.setState({
                fields: fields,
                rowFields: newFields,
                body: "body" + Math.random(),
            }, function () {
            });
        };
        /**
         * 增加列字段
         */
        _this._rightCol = function () {
            var selectFields = _this.fieldsRef.getValue() || [];
            if (selectFields.length > 1) {
                Message_1.default.showMessage((0, utils_1.getTranslate)(null, "当前版本暂不支持多列转置操作"));
                return;
            }
            if (selectFields.length === 0) {
                Message_1.default.showMessage((0, utils_1.getTranslate)(null, "至少选择一项"));
                return;
            }
            var colFields = _this.state.colFields || [];
            if (colFields.length > 0) {
                Message_1.default.showMessage((0, utils_1.getTranslate)(null, "当前版本暂不支持多列转置操作"));
                return;
            }
            selectFields.forEach(function (item) {
                colFields.push(item);
            });
            var newFields = _this.state.fields.filter(function (itm) {
                var found = false;
                for (var i = 0; i < selectFields.length; i++) {
                    try {
                        if (itm.title === selectFields[i].title) {
                            found = true;
                            break;
                        }
                    }
                    catch (e) {
                    }
                }
                return !found;
            });
            _this.setState({
                fields: newFields,
                colFields: colFields,
                body: "body" + Math.random(),
            }, function () {
            });
        };
        /**
         * 移除列字段
         */
        _this._leftCol = function () {
            var selectFields = _this.colFieldsRef.getValue() || [];
            var fields = _this.state.fields || [];
            selectFields.forEach(function (item) {
                fields.push(item);
            });
            var newFields = _this.state.colFields.filter(function (itm) {
                var found = false;
                for (var i = 0; i < selectFields.length; i++) {
                    try {
                        if (itm.title === selectFields[i].title) {
                            found = true;
                            break;
                        }
                    }
                    catch (e) {
                    }
                }
                return !found;
            });
            _this.setState({
                fields: fields,
                colFields: newFields,
                body: "body" + Math.random(),
            }, function () {
            });
        };
        /**
         * 增加值字段
         */
        _this._rightValue = function () {
            var selectFields = _this.fieldsRef.getValue() || [];
            if (selectFields.length > 1) {
                Message_1.default.showMessage((0, utils_1.getTranslate)(null, "当前版本暂不支持多值转置操作"));
                return;
            }
            if (selectFields.length === 0) {
                Message_1.default.showMessage((0, utils_1.getTranslate)(null, "至少选择一项"));
                return;
            }
            var valueFields = _this.state.valueFields || [];
            if (valueFields.length > 0) {
                Message_1.default.showMessage((0, utils_1.getTranslate)(null, "当前版本暂不支持多值转置操作"));
                return;
            }
            selectFields.forEach(function (item) {
                valueFields.push(item);
            });
            var newFields = _this.state.fields.filter(function (itm) {
                var found = false;
                for (var i = 0; i < selectFields.length; i++) {
                    try {
                        if (itm.title === selectFields[i].title) {
                            found = true;
                            break;
                        }
                    }
                    catch (e) {
                    }
                }
                return !found;
            });
            _this.setState({
                fields: newFields,
                valueFields: valueFields,
                body: "body" + Math.random(),
                valueContainerKey: "valueContainerKey" + Math.random(),
            }, function () {
            });
        };
        /**
         * 移除值字段
         */
        _this._leftValue = function () {
            var selectFields = _this.valueFieldsRef.getValue() || [];
            var fields = _this.state.fields || [];
            selectFields.forEach(function (item) {
                fields.push(item);
            });
            var newFields = _this.state.valueFields.filter(function (itm) {
                var found = false;
                for (var i = 0; i < selectFields.length; i++) {
                    try {
                        if (itm.title === selectFields[i].title) {
                            found = true;
                            break;
                        }
                    }
                    catch (e) {
                    }
                }
                return !found;
            });
            _this.setState({
                fields: fields,
                valueFields: newFields,
                body: "body" + Math.random(),
            }, function () {
            });
        };
        /**
         * 对话框删除按钮事件
         */
        _this._remove = function () {
            var self = _this;
            tinper_bee_1.Modal.confirm({
                title: (0, utils_1.getTranslate)(null, "确认"),
                content: (0, utils_1.getTranslate)(null, "您真的要删除转置设置吗？"),
                onOk: function () {
                    self.props.remove && self.props.remove();
                },
                onCancel: function () {
                    // do nothing
                },
            });
        };
        /**
         * 对话框确认按钮事件
         */
        _this._ok = function () {
            var result = {
                fields: _this.state.fields,
                valueFields: _this.state.valueFields,
                colFields: _this.state.colFields,
                rowFields: _this.state.rowFields,
            };
            _this.setState({
                show: false,
            }, function () {
                _this.props.ok && _this.props.ok(result);
            });
        };
        /**
         * 重新加载字段信息
         */
        _this._refresh = function () {
            if (_this.props.refresh) {
                var data = _this.props.refresh();
                _this.setState({
                    fields: data,
                    rowFields: [],
                    colFields: [],
                    valueFields: [],
                });
                _this.containerKey = Math.random() + '';
            }
        };
        _this._close = function () {
            _this.setState({
                show: false,
            }, function () {
                _this.props.close && _this.props.close();
            });
        };
        return _this;
    }
    CrossRotate.prototype.componentWillReceiveProps = function (nextProps) {
        this.setState(__assign({}, nextProps));
    };
    CrossRotate.prototype.render = function () {
        var _this = this;
        return (React.createElement(React.Fragment, null,
            React.createElement(tinper_bee_1.Modal, { show: this.state.show, enforceFocus: false, backdropClosable: false, onHide: this._close, style: { width: 550 }, draggable: true },
                React.createElement(tinper_bee_1.Modal.Header, { closeButton: true, closeButtonProps: { fieldId: "closeBtn" } },
                    React.createElement(tinper_bee_1.Modal.Title, null, (0, utils_1.getTranslate)(null, this.props.title || "行列互换设置"))),
                React.createElement(tinper_bee_1.Modal.Body, { key: this.state.body },
                    React.createElement("div", { style: { marginBottom: 6 } },
                        React.createElement("span", { style: { color: "red" } }, (0, utils_1.getTranslate)(null, "提示")),
                        "\u00A0",
                        (0, utils_1.getTranslate)(null, "考虑效率，请确保原始数据不超过1000条，且不要开启分页")),
                    React.createElement("div", { className: "CrossRotateLeftField", style: { height: 300 } },
                        React.createElement(FieldsContainer, { key: this.containerKey, title: (0, utils_1.getTranslate)(null, "备选字段列表"), fields: this.state.fields, cRef: function (el) { return _this.fieldsRef = el; } })),
                    React.createElement("div", { style: {
                            width: 100,
                            height: 300,
                            float: "left",
                            textAlign: "center",
                        } },
                        React.createElement("div", { style: { marginBottom: 40 } },
                            React.createElement(tinper_bee_1.Button, { key: "rightRow", bordered: true, size: "sm", onClick: this._rightRow },
                                React.createElement(tinper_bee_1.Icon, { type: "uf-arrow-right-2" })),
                            React.createElement("br", null),
                            React.createElement("br", null),
                            React.createElement(tinper_bee_1.Button, { key: "leftRow", bordered: true, size: "sm", onClick: this._leftRow },
                                React.createElement(tinper_bee_1.Icon, { type: "uf-arrow-left-2" }))),
                        React.createElement("div", { style: { marginBottom: 40 } },
                            React.createElement(tinper_bee_1.Button, { key: "rightCol", bordered: true, size: "sm", onClick: this._rightCol },
                                React.createElement(tinper_bee_1.Icon, { type: "uf-arrow-right-2" })),
                            React.createElement("br", null),
                            React.createElement("br", null),
                            React.createElement(tinper_bee_1.Button, { key: "leftCol", bordered: true, size: "sm", onClick: this._leftCol },
                                React.createElement(tinper_bee_1.Icon, { type: "uf-arrow-left-2" }))),
                        React.createElement("div", { style: { marginBottom: 40 } },
                            React.createElement(tinper_bee_1.Button, { key: "rightValue", bordered: true, size: "sm", onClick: this._rightValue },
                                React.createElement(tinper_bee_1.Icon, { type: "uf-arrow-right-2" })),
                            React.createElement("br", null),
                            React.createElement("br", null),
                            React.createElement(tinper_bee_1.Button, { key: "leftValue", bordered: true, size: "sm", onClick: this._leftValue },
                                React.createElement(tinper_bee_1.Icon, { type: "uf-arrow-left-2" })))),
                    React.createElement("div", { className: "CrossRotateLeftField", style: { height: 100 } },
                        React.createElement(FieldsContainer, { key: this.containerKey, title: (0, utils_1.getTranslate)(null, "行字段列表"), fields: this.state.rowFields, cRef: function (el) { return _this.rowFieldsRef = el; } })),
                    React.createElement("div", { className: "CrossRotateLeftField", style: { height: 100 } },
                        React.createElement(FieldsContainer, { key: this.containerKey, title: (0, utils_1.getTranslate)(null, "列字段列表"), fields: this.state.colFields, cRef: function (el) { return _this.colFieldsRef = el; } })),
                    React.createElement("div", { className: "CrossRotateLeftField", style: { height: 100 } },
                        React.createElement(FieldsContainer, { key: this.containerKey, title: (0, utils_1.getTranslate)(null, "值字段列表"), fields: this.state.valueFields, cRef: function (el) { return _this.valueFieldsRef = el; } }))),
                React.createElement(tinper_bee_1.Modal.Footer, null,
                    React.createElement(tinper_bee_1.Button, { style: { display: this.props.refresh ? "unset" : "none" }, onClick: this._refresh, bordered: true }, (0, utils_1.getTranslate)(null, "重置")),
                    React.createElement(tinper_bee_1.Button, { onClick: this._remove, bordered: true }, (0, utils_1.getTranslate)(null, "删除")),
                    React.createElement(tinper_bee_1.Button, { onClick: this._ok, colors: 'primary' }, (0, utils_1.getTranslate)(null, "确定")),
                    " ",
                    "\u00A0\u00A0"))));
    };
    return CrossRotate;
}(react_1.PureComponent));
exports.default = CrossRotate;
